import { Coffee, Leaf, Truck, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import ProductCard from "../ui/ProductCard";

const coffeeProducts = [
  {
    id: 101,
    image: "/images/products/coffee1.jpg",
    category: "Coffee",
    name: "Morning Roast",
    price: 18,
    rating: 4.9,
    badge: "Best Seller",
  },
  {
    id: 102,
    image: "/images/products/coffee2.jpg",
    category: "Coffee",
    name: "Ethiopian Yirgacheffe",
    price: 24,
    rating: 5,
    badge: "New",
  },
  {
    id: 103,
    image: "/images/products/coffee3.jpg",
    category: "Coffee",
    name: "House Blend",
    price: 21,
    rating: 4.8,
    badge: "Organic",
  },
];

export default function CoffeeSection() {
  return (
    <section className="bg-white py-28">

      <div className="mx-auto max-w-7xl px-6">

        <div className="grid items-center gap-20 lg:grid-cols-2">

          {/* Image */}

          <div className="relative">

            <img
              src="/images/coffee-story.jpg"
              alt="Coffee"
              className="rounded-[40px] shadow-2xl"
            />

            {/* Floating Card */}

            <div className="absolute bottom-8 left-8 rounded-3xl bg-white p-6 shadow-xl">

              <p className="text-sm uppercase tracking-[3px] text-[#6B8E5F]">
                Since 2020
              </p>

              <h3 className="mt-2 text-2xl font-semibold">
                Roasted Weekly
              </h3>

            </div>

          </div>

          {/* Text */}

          <div>

            <span className="uppercase tracking-[4px] text-[#6B8E5F]">
              Specialty Coffee
            </span>

            <h2 className="mt-5 text-5xl font-semibold leading-tight">

              Every Morning
              <br />

              Starts Here.

            </h2>

            <p className="mt-8 text-lg leading-8 text-gray-600">

              We source exceptional beans from sustainable farms
              and roast them in small batches to preserve their
              natural sweetness, complexity, and aroma.

              Whether you're beginning a quiet morning or sharing
              coffee with friends, every cup is crafted to slow
              life down.

            </p>

            {/* Features */}

            <div className="mt-12 space-y-6">

              <div className="flex items-center gap-4">

                <div className="rounded-full bg-[#6B8E5F]/10 p-4">

                  <Coffee className="text-[#6B8E5F]" />

                </div>

                <div>

                  <h4 className="font-semibold">
                    Freshly Roasted Weekly
                  </h4>

                  <p className="text-gray-500">
                    Small-batch roasted for maximum freshness.
                  </p>

                </div>

              </div>

              <div className="flex items-center gap-4">

                <div className="rounded-full bg-[#6B8E5F]/10 p-4">

                  <Leaf className="text-[#6B8E5F]" />

                </div>

                <div>

                  <h4 className="font-semibold">
                    Sustainably Sourced
                  </h4>

                  <p className="text-gray-500">
                    Partnering directly with ethical growers.
                  </p>

                </div>

              </div>

              <div className="flex items-center gap-4">

                <div className="rounded-full bg-[#6B8E5F]/10 p-4">

                  <Truck className="text-[#6B8E5F]" />

                </div>

                <div>

                  <h4 className="font-semibold">
                    Delivered Fresh
                  </h4>

                  <p className="text-gray-500">
                    Ships within 24 hours of roasting.
                  </p>

                </div>

              </div>

            </div>

            <Link
              to="/shop/coffee"
              className="mt-12 inline-flex items-center gap-3 rounded-full bg-[#6B8E5F] px-8 py-4 text-white transition hover:bg-[#557149]"
            >

              Shop Coffee

              <ArrowRight size={18} />

            </Link>

          </div>

        </div>

        {/* Coffee Products */}

        <div className="mt-24">

          <div className="mb-10 flex items-center justify-between">

            <h3 className="text-3xl font-semibold">
              Featured Coffee
            </h3>

            <Link
              to="/shop/coffee"
              className="text-[#6B8E5F] hover:underline"
            >
              View All
            </Link>

          </div>

          <div className="grid gap-8 md:grid-cols-2 xl:grid-cols-3">

            {coffeeProducts.map((product) => (
              <ProductCard
                key={product.id}
                {...product}
              />
            ))}

          </div>

        </div>

      </div>

    </section>
  );
}